import { base } from "../../../constants";
import moduleRoutes from "../../../routes/moduleRouteList";
import PageRouterList from "../../../routes/routeList";

export function getEmrEncounterBasePath(): string {
  return `${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${PageRouterList.emr}/`;
}

export function buildEmrEncounterUrl(
  encounterId: number,
  patientMasterId: number,
  emrNo: string,
): string {
  const basePath = getEmrEncounterBasePath();
  const query = emrNo ? `?emrno=${encodeURIComponent(emrNo)}` : "";
  return `${basePath}${encounterId}/${patientMasterId}${query}`;
}
